import React from 'react';
import './Filters.css';

const Filters = ({ filters, updateFilter, clearAllFilters }) => {
  const breeds = {
    Dog: ['Rottweiler', 'Golden Retriever', 'Labrador', 'German Shepherd', 'Beagle'],
    Cat: ['Persian Cat', 'Siamese Cat', 'British Shorthair'],
    Rabbit: ['Dutch Rabbit', 'Flemish Giant']
  };

  const getAllBreeds = () => {
    return [...new Set(Object.values(breeds).flat())];
  };

  return (
    <div className="filters-section">
      <div className="filters-header">
        <h3>Filters</h3>
        <button className="clear-all-btn" onClick={clearAllFilters}>
          Clear All
        </button>
      </div>

      <div className="filter-group">
        <h4>Adopt / Rehome</h4>
        <div className="toggle-buttons">
          <button
            className={`toggle-btn ${filters.adoptOrRehome === 'Adopt' ? 'active' : ''}`}
            onClick={() => updateFilter('adoptOrRehome', 'Adopt')}
          >
            Adopt
          </button>
          <button
            className={`toggle-btn ${filters.adoptOrRehome === 'Rehome' ? 'active' : ''}`}
            onClick={() => updateFilter('adoptOrRehome', 'Rehome')}
          >
            Rehome
          </button>
        </div>
      </div>

      <div className="filter-group">
        <h4>Pet Type</h4>
        <div className="checkbox-group">
          {['Dog', 'Cat', 'Rabbit'].map(type => (
            <label key={type} className="checkbox-label">
              <input
                type="checkbox"
                checked={filters.petType.includes(type)}
                onChange={() => updateFilter('petType', type)}
              />
              <span>{type}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="filter-group">
        <h4>Gender</h4>
        <div className="checkbox-group">
          {['Male', 'Female'].map(gender => (
            <label key={gender} className="checkbox-label">
              <input
                type="checkbox"
                checked={filters.gender.includes(gender)}
                onChange={() => updateFilter('gender', gender)}
              />
              <span>{gender}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="filter-group">
        <h4>Breed</h4>
        <select
          className="breed-dropdown"
          onChange={(e) => {
            if (e.target.value && !filters.breed.includes(e.target.value)) {
              updateFilter('breed', e.target.value);
            }
          }}
          value=""
        >
          <option value="">Select Breed</option>
          {getAllBreeds().map(breed => (
            <option key={breed} value={breed}>
              {breed}
            </option>
          ))}
        </select>
        {filters.breed.length > 0 && (
          <div className="selected-breeds">
            {filters.breed.map(breed => (
              <span key={breed} className="breed-tag">
                {breed}
                <button onClick={() => updateFilter('breed', breed)}>×</button>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Filters;
